import { BreakpointsTypes } from "./interfaces/IBreakpoints";

export enum AssetsTypes {
    CSS = "css",
    TICKET_BACKGROUND_COLOR = "tickerBackgroundColor",
    LOGO = "logo",
    DISPLAY_DESCRIPTION = "displayDescription",
    DISPLAY_NAME = "displayName",
    WIDGET_GAMES_SLIDER = "widget-games-slider",
    WIDGET_CSS = "widget-css",
    HEAT_ANIMATION_COLOR = 'heatAnimationColor',
    CONSTANT_TICK_UP_ENABLE = "constantTickupEnable",
    CONSTANT_TICK_UP_ANIMATION_TIME = "constantTickupAnimationTime",
    CONSTANT_TICK_UP_INITIAL_DECREASE = "constantTickupInitialDecrease",
}

export enum FeatureSize {
    LARGE = "LARGE",
    SMALL = "SMALL",
}

export const BREAKPOINTS_WIDTH = {
    [BreakpointsTypes.XL]: 890,
    [BreakpointsTypes.L]: 801,
    [BreakpointsTypes.M]: 701,
    [BreakpointsTypes.S]: 561,
    [BreakpointsTypes.XS]: 450,
    [BreakpointsTypes.XXS]: 0,
}

export const BREAKPOINTS_HEIGHT = {
    [BreakpointsTypes.XXL]: 400,
    [BreakpointsTypes.XL]: 350,
    [BreakpointsTypes.L]: 300,
    [BreakpointsTypes.M]: 250,
    [BreakpointsTypes.S]: 180,
    [BreakpointsTypes.XS]: 112,
    [BreakpointsTypes.XXS]: 0,
}

export enum DispatchEvents {
    SetState = "SetState",
    SetFeatures = "SetFeatures",
    SetAssets = "SetAssets",
    Reset = "Reset",
}
